import styled from "styled-components";

import { Row } from "components/common";
import colors from "styles/colors";

const Container = styled(Row)`
  flex-wrap: wrap;
  margin-bottom: 10px;
`;

const FilterContainer = styled(Row)`
  white-space: nowrap;
  line-height: 2em;
`;

const FilterLabel = styled.text`
  font-weight: bold;
  margin-right: 4px;
  white-space: nowrap;
`;

const FilterValue = styled.div`
  color: ${({ hasColor }) =>
    hasColor ? colors.coreColors.jllRed.primary : ""};
`;

const VerticalDivider = styled.div`
  &::before {
    content: "|";
  }
  margin: 0px 12px;
`;

export {
  Container,
  FilterContainer,
  FilterLabel,
  FilterValue,
  VerticalDivider,
};
